/**
 * Bike Compare – Manages product comparison with floating bar and spec drawer.
 * Max 3 products. Uses MtsStorage for persistence.
 * Reads specs from bidex_variant_attrs metafields.
 */
(function () {
  'use strict';

  // Bumped from 'mts-compare' to 'mts-compare-v2' when brandLogo/brandName fields
  // were added. Old entries without these fields become stale → purge on upgrade.
  var KEY = 'mts-compare-v2';
  var LEGACY_KEY = 'mts-compare';
  var MAX = 3;
  try { if (localStorage.getItem(LEGACY_KEY)) localStorage.removeItem(LEGACY_KEY); } catch (e) {}

  var SPEC_ROWS = [
    { key: 'category', label: 'Kategorie' },
    { key: 'frame', label: 'Rahmen' },
    { key: 'frame-form', label: 'Rahmenform' },
    { key: 'color', label: 'Farbe' },
    { key: 'weight', label: 'Gewicht' },
    { key: 'motor', label: 'Motor' },
    { key: 'battery', label: 'Akku' },
    { key: 'battery-wh', label: 'Akku-Kapazität' },
    { key: 'gears', label: 'Schaltungstyp' },
    { key: 'shifter', label: 'Schaltwerk' },
    { key: 'brake-type', label: 'Bremsentyp' },
    { key: 'brakes', label: 'Bremsen' },
    { key: 'fork', label: 'Federgabel' },
    { key: 'tires', label: 'Reifen' },
    { key: 'wheels', label: 'Laufradgröße' },
    { key: 'max-weight', label: 'Zul. Gesamtgewicht' }
  ];

  function esc(str) {
    var el = document.createElement('span');
    el.textContent = str || '';
    return el.innerHTML;
  }

  function getProductData(btn) {
    var d = btn.dataset;
    var data = {
      handle: d.compareHandle,
      title: d.compareTitle,
      url: d.compareUrl,
      image: d.compareImage,
      price: d.comparePrice,
      priceRaw: d.comparePriceRaw,
      vendor: d.compareVendor,
      brandName: d.compareBrandName || d.compareVendor || '',
      brandLogo: d.compareBrandLogo || ''
    };
    SPEC_ROWS.forEach(function (spec) {
      data[spec.key] = d['compare' + spec.key.split('-').map(function(p,i) {
        return i === 0 ? p : p.charAt(0).toUpperCase() + p.slice(1);
      }).join('')] || '-';
    });
    // Also try camelCase directly from dataset
    data['category'] = d.compareCategory || '-';
    data['frame'] = d.compareFrame || '-';
    data['frame-form'] = d.compareFrameForm || '-';
    data['weight'] = d.compareWeight || '-';
    data['motor'] = d.compareMotor || '-';
    data['battery'] = d.compareBattery || '-';
    data['battery-wh'] = d.compareBatteryWh || '-';
    data['gears'] = d.compareGears || '-';
    data['shifter'] = d.compareShifter || '-';
    data['brakes'] = d.compareBrakes || '-';
    data['brake-type'] = d.compareBrakeType || '-';
    data['fork'] = d.compareFork || '-';
    data['tires'] = d.compareTires || '-';
    data['wheels'] = d.compareWheels || '-';
    data['color'] = d.compareColor || '-';
    data['max-weight'] = d.compareMaxWeight || '-';
    data['size'] = d.compareSize || '-';
    return data;
  }

  // --- Bar rendering ---
  function renderBar() {
    var items = window.MtsStorage ? window.MtsStorage.getItems(KEY) : [];
    var bar = document.getElementById('mts-compare-bar');
    var container = document.getElementById('compare-bar-items');
    var countEl = document.getElementById('compare-bar-count');
    var openBtn = document.getElementById('compare-bar-open');

    if (!bar || !container) return;

    if (items.length === 0) {
      bar.classList.remove('is-visible');
      return;
    }

    bar.classList.add('is-visible');
    if (countEl) countEl.textContent = items.length;
    if (openBtn) openBtn.disabled = items.length < 2;

    container.innerHTML = items.map(function (item) {
      return '<div class="compare-bar__item">' +
        '<img src="' + esc(item.image) + '" alt="" width="56" height="56" loading="lazy">' +
        '<span class="compare-bar__item-title">' + esc(item.title) + '</span>' +
        '<button type="button" class="compare-bar__item-remove" data-remove-handle="' + esc(item.handle) + '" aria-label="Entfernen">&times;</button>' +
        '</div>';
    }).join('');
  }

  // If an item is missing fields (e.g. brandLogo after a schema upgrade) and
  // a matching compare button is present on the current page, enrich from DOM.
  function enrichFromDom(items) {
    items.forEach(function (p) {
      if (p.brandLogo && p.brandName) return;
      var btn = document.querySelector('.mts-compare-btn[data-compare-handle="' + (p.handle || '').replace(/"/g, '\\"') + '"]');
      if (!btn) return;
      var fresh = getProductData(btn);
      Object.keys(fresh).forEach(function (k) {
        if (!p[k] || p[k] === '-') p[k] = fresh[k];
      });
    });
    return items;
  }

  // --- Drawer rendering ---
  function renderDrawer() {
    var items = window.MtsStorage ? window.MtsStorage.getItems(KEY) : [];
    items = enrichFromDom(items);
    var table = document.getElementById('compare-table');
    if (!table || items.length === 0) return;

    var n = items.length;
    var html = '';

    function renderSpec(label, valueHtmlFn) {
      html += '<tr class="compare-drawer__label-row"><th colspan="' + n + '">' + esc(label) + '</th></tr>';
      html += '<tr class="compare-drawer__value-row">';
      items.forEach(function (p) {
        html += '<td>' + valueHtmlFn(p) + '</td>';
      });
      html += '</tr>';
    }

    // Product row: image + title (no label above – image+title speak for themselves)
    html += '<tr class="compare-drawer__product-row">';
    items.forEach(function (p) {
      html += '<td>' +
        '<img class="compare-drawer__product-img" src="' + esc(p.image) + '" alt="" loading="lazy">' +
        '<a href="' + esc(p.url) + '" class="compare-drawer__product-title">' + esc(p.title) + '</a>' +
        '</td>';
    });
    html += '</tr>';

    renderSpec('Marke', function (p) {
      if (p.brandLogo) {
        var alt = esc(p.brandName || p.vendor || '');
        return '<img class="compare-drawer__brand-logo" src="' + esc(p.brandLogo) + '" alt="' + alt + '" loading="lazy">';
      }
      return esc(p.brandName || p.vendor || '-');
    });
    renderSpec('Preis', function (p) { return '<span class="compare-drawer__price">' + esc(p.price) + '</span>'; });

    // Spec rows – only show rows where at least one product has data
    SPEC_ROWS.forEach(function (spec) {
      var hasData = items.some(function (p) { return p[spec.key] && p[spec.key] !== '-'; });
      if (!hasData) return;
      renderSpec(spec.label, function (p) { return esc(p[spec.key] || '-'); });
    });

    // Remove buttons
    html += '<tr class="compare-drawer__remove-row">';
    items.forEach(function (p) {
      html += '<td><button type="button" class="compare-drawer__remove-btn" data-remove-handle="' + esc(p.handle) + '">Entfernen</button></td>';
    });
    html += '</tr>';

    table.innerHTML = html;
  }

  function openDrawer() {
    var drawer = document.getElementById('mts-compare-drawer');
    if (!drawer) return;
    renderDrawer();
    drawer.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    document.body.classList.add('mts-compare-drawer-open');
    var closeBtn = document.getElementById('compare-drawer-close');
    if (closeBtn) closeBtn.focus();
  }

  function closeDrawer() {
    var drawer = document.getElementById('mts-compare-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.body.classList.remove('mts-compare-drawer-open');
  }

  // --- Button state sync ---
  function syncButtons() {
    if (!window.MtsStorage) return;
    var btns = document.querySelectorAll('.mts-compare-btn');
    btns.forEach(function (btn) {
      var handle = btn.dataset.compareHandle;
      var active = window.MtsStorage.hasItem(KEY, handle);
      btn.setAttribute('aria-pressed', String(active));
      btn.classList.toggle('is-active', active);
    });
  }

  // --- Event handlers ---
  function onCompareClick(e) {
    var btn = e.target.closest('.mts-compare-btn');
    if (!btn || !window.MtsStorage) return;

    var data = getProductData(btn);
    var items = window.MtsStorage.getItems(KEY);

    if (window.MtsStorage.hasItem(KEY, data.handle)) {
      window.MtsStorage.removeItem(KEY, data.handle);
    } else {
      if (items.length >= MAX) {
        window.MtsStorage.removeItem(KEY, items[items.length - 1].handle);
      }
      window.MtsStorage.addItem(KEY, data);
    }
    syncButtons();
    renderBar();
  }

  function onRemoveClick(e) {
    var btn = e.target.closest('[data-remove-handle]');
    if (!btn || !window.MtsStorage) return;
    window.MtsStorage.removeItem(KEY, btn.dataset.removeHandle);
    syncButtons();
    renderBar();
    renderDrawer();
    if (window.MtsStorage.getCount(KEY) < 2) closeDrawer();
  }

  function init() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('.mts-compare-btn')) {
        e.preventDefault();
        e.stopPropagation();
        onCompareClick(e);
      }
      if (e.target.closest('[data-remove-handle]')) {
        e.preventDefault();
        onRemoveClick(e);
      }
    });

    var clearBtn = document.getElementById('compare-bar-clear');
    var openBtn = document.getElementById('compare-bar-open');
    var closeBtn = document.getElementById('compare-drawer-close');
    var drawer = document.getElementById('mts-compare-drawer');

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (window.MtsStorage) window.MtsStorage.clear(KEY);
        syncButtons();
        renderBar();
      });
    }

    if (openBtn) openBtn.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) closeDrawer();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
    });

    document.addEventListener('mts:storage-changed', function (e) {
      if (e.detail && e.detail.key === KEY) { syncButtons(); renderBar(); }
    });

    syncButtons();
    renderBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
